import { render, staticRenderFns } from "./ReferralResume.vue?vue&type=template&id=1fdc707b&scoped=true&"
import script from "./ReferralResume.vue?vue&type=script&lang=ts&"
export * from "./ReferralResume.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralResume.vue?vue&type=style&index=0&id=1fdc707b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc707b",
  null
  
)

export default component.exports